import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ArchivoCentralService } from '../../services/archivo-central.service';
import { debounceTime } from 'rxjs/operators';
import { BandejaService } from '../../services/bandeja.service';
import { NavbarService } from '../navbar/navbar.service';

@Component({
  selector: 'app-archivos-5-autocomplete',
  templateUrl: './archivos-nivel5-autocomplete.component.html',
  styleUrls: ['./archivos-nivel5-autocomplete.component.scss']
})
export class ArchivosNivel5AutocompleteComponent implements OnInit {

    @Input('control') control: FormControl

    @Input('nivel1') nivel1: string

    @Input('nivel2') nivel2: string

    @Input('nivel3') nivel3: string

    @Input('nivel4') nivel4: string

    @Input('label') label: string

    @Input('placeholder') placeholder: string

    @Input('disable') set disable(value: boolean) {
        if (value) {
            this.inputControl.enable();
        } else {
            this.control.setValue('');
            this.inputControl.setValue('');
            this.inputControl.disable();
        }
    }

    @Output('onOptionSelected') onOptionSelected = new EventEmitter<RemitentePorArea>()

    inputControl = new FormControl({value: ''})

    options: RemitentePorArea[] = []

    optionSelected: RemitentePorArea;

    loading = false;

    optionsEmpty = false;
    private _subs = new Subscription()


  constructor(
    private _archivoService: ArchivoCentralService,
  ) { }

  ngOnInit(): void {
    if (!this.nivel3) {
      this.inputControl = new FormControl({ value: '', disabled: true });
    }

    const inputSub = this.inputControl.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      if (value == '') {
        this.control.setValue('')
        /*this.options = []
        return*/
      }

      this.loading = true
      this.optionsEmpty = false;
      this.options = []

      this._archivoService.getArchivoslistaNivel5({
        criterio: value, nivel1: this.nivel1, nivel2: this.nivel2, nivel3: this.nivel3, nivel4: this.nivel4
      }).then((list: any) => {
        this.options = list
        this.loading = false
        this.optionsEmpty = !Boolean(list.length)
      })
    });
    this._subs.add(inputSub)
  }

  ngOnDestroy(){
        this._subs.unsubscribe();
  }

    setOptionSelected(event) {
        this.optionSelected = event.option.value

        this.onOptionSelected.emit(this.optionSelected)

        const label = event.option.value

        this.inputControl.setValue(label)
        this.control.setValue(label)

    }

    onFocus() {
        this.options = []
        this.optionsEmpty = false;

        this.inputControl.setValue('')
    }

    cleanControl() {
        this.inputControl.setValue('')
        this.control.setValue('')
    }

}
export interface RemitentePorArea {
    cargo: string
    idPersona: number
    nombresCompletos: string
    username: string
    usernamePadre: string
    label?: string
}

